export default __webpack_public_path__ + "static/media/staricon.060c9f0e.svg";